import { css } from "@emotion/react";
import React, { forwardRef } from "react";
import { PartialColorProps, useTheme } from "../theme";

export type SVGPathProps = React.SVGAttributes<SVGPathElement>;

export const SVGFillPath = ({ ...props }: SVGPathProps) => {
  return (
    <path
      css={css`
        fill: var(--icon-primary-color);
        transform-origin: 50% 50%;
      `}
      {...props}
    />
  );
};

export const SVGStrokePath = ({ ...props }: SVGPathProps) => {
  return (
    <path
      css={css`
        stroke: var(--icon-primary-color);
        transform-origin: 50% 50%;
      `}
      {...props}
    />
  );
};

export type SVGCircleProps = React.SVGAttributes<SVGCircleElement>;

export const SVGFillCircle = ({ ...props }: SVGCircleProps) => {
  return (
    <circle
      css={css`
        fill: var(--icon-primary-color);
        transform-origin: 50% 50%;
      `}
      {...props}
    />
  );
};

export type SVGRectProps = React.SVGAttributes<SVGRectElement>;

export const SVGFillRect = ({ ...props }: SVGRectProps) => {
  return (
    <rect
      css={css`
        fill: var(--icon-primary-color);
        transform-origin: 50% 50%;
      `}
      {...props}
    />
  );
};

export interface SVGIconRootProps
  extends Omit<React.SVGAttributes<SVGElement>, "color">, PartialColorProps {
  /**
   * @default "none"
   */
  fill?: string;
}

export const SVGIconRoot = forwardRef<SVGSVGElement, SVGIconRootProps>(
  ({ color = "default", ...props }, ref) => {
    const theme = useTheme();
    return (
      <svg
        ref={ref}
        fill="none"
        css={css`
          --icon-primary-color: ${color === "default"
            ? "currentColor"
            : theme.palette.intentions[color].main};
          width: 1em;
          height: 1em;
          font-size: 1.2em;
          vertical-align: sub;
        `}
        {...props}
      />
    );
  },
);
